import { cn } from '@/lib/utils'

interface PanelSkeletonProps {
  className?: string
  count?: number
}

export function PanelSkeleton({ className, count = 1 }: PanelSkeletonProps) {
  if (count > 1) {
    return (
      <div className={className}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="h-24 rounded-md bg-muted/40 animate-pulse" />
        ))}
      </div>
    )
  }
  return <div className={cn('rounded-md bg-muted/40 animate-pulse', className)} />
}
